// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-sm":"(min-width: 768px)","mediaBreakpointSm":"(min-width: 768px)","wrapper":"_2aLokWne","header":"pYDK6ZuO","border":"_2_wCPvfW"};